import { createUseStyles } from 'react-jss';

import styling from '../../services/styling';

export default createUseStyles(
  {
    backdrop: {
      position: 'fixed',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      backgroundColor: styling.colors.context.background,
      opacity: 0.8,
    },
    'variant-panel': {
      zIndex: styling.zIndex.backdrops.panel,
    },
    'variant-alert': {
      zIndex: styling.zIndex.backdrops.alert,
    },
    backdropOnClick: {
      cursor: 'pointer',
    },
  },
  { name: 'backdrop' },
);
